import { Text, Image, Link } from '@fluentui/react-components';
import React from 'react';
import { useNoAccessPageStyles } from './NoAccessPage.styles';
import { noAccessPage } from '../resources';
import { AppConstants } from '../..';

export const NoAccessPage = () => {
  const styles = useNoAccessPageStyles();
  return (
    <div className={styles.container}>
      <Image src="/assets/error.svg" width={200} height={200} alt="" />
      <div className={styles.contentContainer}>
        <Text size={500} weight="bold">
          {noAccessPage.NoAccessTitle}
        </Text>
        <Text size={300}>
          {noAccessPage.NoAccessDescriptionStart}
          <Link href={AppConstants.ResourcesLink} target={'_blank'}>
            {noAccessPage.roleLibraryLink}
          </Link>
          {noAccessPage.NoAccessDescriptionEnd}
        </Text>
      </div>
    </div>
  );
};
